import { render, staticRenderFns } from "./UploadNumberPricing.vue?vue&type=template&id=465596a8&"
import script from "./UploadNumberPricing.vue?vue&type=script&lang=js&"
export * from "./UploadNumberPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports